import React from 'react';
import { Layout } from '@o2/common-business';
import NewAppBar from './components/NewAppBar';
import NewAppBarInternal from './components/NewAppBarInternal';
import { RouteRender } from 'helpers/routes/routeRender';
import routes from 'helpers/routes/routes';
import UserActivity from 'views/components/UserActivity/UserActivity';
import SupportingTools from 'views/testing-tools/SupportingTools';
import CustomerRequestContainer from 'views/components/CustomerRequest/CustomerRequestContainer';
import Loading from '@o2/common-business/Loading';
import { useLocation } from 'react-router-dom';
import { AppLayout } from '@o2/ui';

interface Props {
  isInternal: boolean | undefined;
}

export const NewAppLayout = ({ isInternal }: Props): JSX.Element => {
  const location = useLocation();

  // TODO: only some pages in entityAccessManagement has support for new layout
  const newLayoutPaths = [
    '/billing',
    '/entityaccessmanagement/create-access',
    '/entityaccessmanagement/verify-entity-access',
    '/entityaccessmanagement/contact-person-access',
    '/entityaccessmanagement/accesses',
    '/entityaccessmanagement/contact-persons',
    '/entityaccessmanagement/contact-person-confirmation',
  ];

  const LayoutComponent = newLayoutPaths.some((path) => location.pathname.startsWith(path)) ? Layout : AppLayout;

  return (
    <>
      <UserActivity />
      <SupportingTools />
      <CustomerRequestContainer />

      <LayoutComponent>
        <Layout.Header>
          {isInternal && <NewAppBarInternal />}
          <NewAppBar />
        </Layout.Header>
        <Layout.Body>
          <React.Suspense fallback={<Loading />}>
            <RouteRender routes={routes} />
          </React.Suspense>
        </Layout.Body>
      </LayoutComponent>
    </>
  );
};
